import {ChangeDetectionStrategy, Component, computed, input, output, signal} from '@angular/core';
import {ConsignmentUtils, GoodsItemSummaryWithHouseConsignments} from "../../../consignment.utils";
import {AppContext} from "../../../../../app-context";
import {CheckboxSelectionState, nonNull, openEditModal} from "../../../../../common/utils";
import {
  GoodsConsignmentDetailsComponent,
  GoodsConsignmentDetailsComponentData
} from "../../../details/goods-consignment-details/goods-consignment-details.component";
import {IE3CustomsInspection, TaskMessageStatus} from "@portbase/bezoekschip-service-typescriptmodels";
import {DeclarationMessageStatus} from "../../../../visit-overview/visit-overview-item/visit-overview.utils";
import lodash from "lodash";

@Component({
    selector: 'app-consignment-bulk-goods-overview-item',
    templateUrl: './consignment-bulk-goods-overview-item.component.html',
    styleUrls: ['./consignment-bulk-goods-overview-item.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConsignmentBulkGoodsOverviewItemComponent {
  appContext = AppContext;

  readonly consignmentProcessId = input<string>();
  readonly inspections = input<IE3CustomsInspection[]>();
  readonly goodsItem = input.required<GoodsItemSummaryWithHouseConsignments>();
  readonly term = input<string>();
  readonly selectable = input<boolean>();
  readonly collapsible = input<boolean>();
  readonly selected = input<boolean>(false);

  readonly highlighted = output<string>();
  readonly selectionToggled = output<void>();
  readonly checkboxSelectionState = CheckboxSelectionState;

  selectionWidth: number = 40;

  collapsed = signal(false);

  readonly dischargeStatus = computed(() => {
    const g = this.goodsItem();
    const taskStatus = g.goodsItem.bulkDischarge
      ? g.goodsItem.bulkDischarge.grossWeight !== g.goodsItem.grossWeight
        ? TaskMessageStatus.WARNING : TaskMessageStatus.ACCEPTED
      : TaskMessageStatus.DISABLED;
    return {
      taskStatus,
      name: 'Discharged',
      messages: taskStatus === 'WARNING' ? ['Terminal reported discharge of ' + g.goodsItem.bulkDischarge.grossWeight + 'kg gross weight'] : []
    };
  });

  readonly inspectionStatus = computed(() =>
    ConsignmentUtils.getInspectionsStatus([lodash.last(this.inspections())])
  );

  readonly terminalStatuses = computed(() =>
    [this.dischargeStatus(), this.inspectionStatus()].filter(nonNull)
      .filter(a => a.taskStatus !== TaskMessageStatus.DISABLED)
  );

  editGoodsItem = () => openEditModal(GoodsConsignmentDetailsComponent, <GoodsConsignmentDetailsComponentData>{
    consignmentProcessId: this.consignmentProcessId(),
    goodsItemNumber: this.goodsItem().goodsItem.goodsItemNumber,
    houseConsignmentNumber: this.goodsItem().houseConsignments?.length === 1 ? this.goodsItem().houseConsignments[0] : null
  }, {
    warnOnClose: true,
    currentToStack: true
  });

  onHighlightMatch() {
    this.highlighted.emit('' + this.goodsItem().goodsItem.goodsItemNumber);
  }
}
